(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maayan-feature-product-new"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // פונקציה לסינון המוצרים
  function filterProducts() {
    const searchValue = document.getElementById('collection-search')?.value?.toLowerCase() || '';
    const priceValue = document.getElementById('price-filter')?.value || '';
    const sizeValue = document.getElementById('size-filter')?.value || '';
    const colorValue = document.getElementById('color-filter')?.value || '';
    const heightValue = document.getElementById('height-filter')?.value || '';
    const sortValue = document.getElementById('sort-filter')?.value || '';

    const products = document.querySelectorAll('#product-grid .grid__item');

    products.forEach(product => {
      let show = true;
      const productData = product.dataset;

      // סינון לפי חיפוש
      if (searchValue && !productData.title?.toLowerCase().includes(searchValue)) {
        show = false;
      }

      // סינון לפי מחיר
      if (priceValue) {
        const [minPrice, maxPrice] = priceValue.split('-').map(Number);
        const price = Number(productData.price);
        if (price < minPrice || price > maxPrice) {
          show = false;
        }
      }

      // סינון לפי מידה
      if (sizeValue && !productData.sizes?.includes(sizeValue)) {
        show = false;
      }

      // סינון לפי צבע
      if (colorValue && !productData.colors?.includes(colorValue)) {
        show = false;
      }

      // סינון לפי הגבהה
      if (heightValue) {
        const [minHeight, maxHeight] = heightValue.split('-').map(Number);
        const height = Number(productData.height);
        if (height < minHeight || height > maxHeight) {
          show = false;
        }
      }

      product.style.display = show ? '' : 'none';
    });

    // מיון המוצרים
    if (sortValue) {
      const productGrid = document.getElementById('product-grid');
      const productsArray = Array.from(products);
      
      productsArray.sort((a, b) => {
        const priceA = Number(a.dataset.price);
        const priceB = Number(b.dataset.price);
        
        if (sortValue === 'price-asc') {
          return priceA - priceB;
        } else if (sortValue === 'price-desc') {
          return priceB - priceA;
        }
        return 0;
      });

      productsArray.forEach(product => {
        productGrid.appendChild(product);
      });
    }
  }

  // הוספת מאזיני אירועים
  const filters = document.querySelectorAll('.filter-select');
  filters.forEach(filter => {
    filter.addEventListener('change', filterProducts);
  });

  const searchInput = document.getElementById('collection-search');
  if (searchInput) {
    searchInput.addEventListener('input', filterProducts);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["MediaSwitchermaayan"] && !window.DesignMode) return;
  try {
    
class MediaSlider {
  constructor(element) {
    this.slider = element;
    this.slides = [...this.slider.querySelectorAll('.slide')];
    this.dots = [...this.slider.querySelectorAll('.dot')];
    this.prevButton = this.slider.querySelector('.slider-arrow.prev');
    this.nextButton = this.slider.querySelector('.slider-arrow.next');
    this.currentIndex = 0;
    this.isAnimating = false;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.effectStyle = this.slider.dataset.effectStyle;

    // ערבוב הסליידים
    this.shuffleSlides();

    this.init();
  }

  // פונקציה לערבוב מערך
  shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  // ערבוב הסליידים והנקודות
  shuffleSlides() {
    this.shuffleArray(this.slides);
    this.shuffleArray(this.dots);

    // עדכון DOM בהתאם לסדר החדש
    const slidesContainer = this.slider.querySelector('.slides-container');
    slidesContainer.innerHTML = ''; // ניקוי הסליידים הנוכחיים
    this.slides.forEach(slide => slidesContainer.appendChild(slide)); // הוספת הסליידים בסדר החדש

    const dotsContainer = this.slider.querySelector('.slider-dots');
    dotsContainer.innerHTML = ''; // ניקוי הנקודות הנוכחיות
    this.dots.forEach(dot => dotsContainer.appendChild(dot)); // הוספת הנקודות בסדר החדש
  }

  init() {
    if (this.slides.length) {
      this.showSlide(0);
      this.bindEvents();
      this.startAutoPlay();
    }
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => !this.isAnimating && this.prevSlide());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => !this.isAnimating && this.nextSlide());
    }

    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.index);
        if (!this.isAnimating && index !== this.currentIndex) {
          this.showSlide(index);
        }
      });
    });

    this.slider.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
      this.stopAutoPlay();
    }, { passive: true });

    this.slider.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      const swipeDistance = this.touchEndX - this.touchStartX;

      if (Math.abs(swipeDistance) > 50) {
        if (swipeDistance > 0) {
          !this.isAnimating && this.prevSlide();
        } else {
          !this.isAnimating && this.nextSlide();
        }
      }
      this.startAutoPlay();
    }, { passive: true });

    this.slider.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.slider.addEventListener('mouseleave', () => this.startAutoPlay());
  }

  showSlide(index) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const currentSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[index];

    this.slides.forEach(slide => {
      slide.classList.remove('active', 'prev', 'next');
    });

    if (this.slider.dataset.transition === 'slide') {
      const direction = index > this.currentIndex ? 'next' : 'prev';
      nextSlide.classList.add(direction);
      setTimeout(() => {
        nextSlide.classList.add('active');
        currentSlide.classList.add(direction === 'next' ? 'prev' : 'next');
      }, 50);
    } else {
      nextSlide.classList.add('active');
    }

    this.dots.forEach(dot => dot.classList.remove('active'));
    this.dots[index]?.classList.add('active');

    this.currentIndex = index;

    setTimeout(() => {
      this.isAnimating = false;
    }, parseFloat(getComputedStyle(nextSlide).transitionDuration) * 1000 + 100);
  }

  nextSlide() {
    const newIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(newIndex);
  }

  prevSlide() {
    const newIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(newIndex);
  }

  startAutoPlay() {
    if (this.slider.dataset.autoplay === 'true' && !this.autoPlayInterval) {
      const speed = parseInt(this.slider.dataset.autoplaySpeed);
      this.autoPlayInterval = setInterval(() => {
        if (!this.isAnimating) {
          this.nextSlide();
        }
      }, speed);
    }
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.media-slider');
  sliders.forEach(slider => new MediaSlider(slider));
});
  

  } catch(e) { console.error(e); }
})();
})();
